// BonusCertificate.constants.js
(function() {
    'use strict';

    angular
        .module('app.constants')
        .constant("BonusCertificate", {
            "mobile": {
                "inSubscription": [{
                        label: 'valor',
                        value: 'valor',
                        notSortable: true
                    },
                    {
                        label: 'couponPercentPa',
                        value: 'couponPercentPa',
                        precision: 2
                    },
                    {
                        label: 'underlyingNames',
                        value: 'underlyingNames',
                        icon: 'settlementMethodIcon'
                    },
                    {
                        label: 'currency',
                        value: 'currency',
                        icon: 'quantoIcon'
                    },
                    {
                        label: 'barrierLevelRelativePercent',
                        value: 'barrierLevelRelativePercent',
                        precision: 2
                    },
                    {
                        label: 'maturityDate',
                        value: 'maturityDate',
                        icon: 'earlyRedemptionIcon',
                        format: 'mediumDate'
                    },
                    {
                        label: 'subscriptionPeriodEndDateMobile',
                        value: 'subscriptionPeriodEndDate',
                        format: 'customDateTime'
                    },
                    {
                        label: ' ',
                        value: 'menu',
                        align: 'right',
                        notSortable: true
                    }
                ],
                "secondaryMarket": [{
                        label: 'valor',
                        value: 'valor',
                        notSortable: true
                    },
                    {
                        label: 'maxPerformancePercentStrikeCurrency',
                        value: 'maxPerformancePercentStrikeCurrency',
                        precision: 2
                    },
                    {
                        label: 'couponPercentPa',
                        value: 'couponPercentPa',
                        precision: 2
                    },
                    {
                        label: 'underlyingNames',
                        value: 'underlyingNames',
                        icon: 'settlementMethodIcon'
                    },
                    {
                        label: 'currency',
                        value: 'currency',
                        icon: 'quantoIcon'
                    },
                    {
                        label: 'distance2BarrierLevelPercent',
                        value: 'distance2BarrierLevelPercent',
                        precision: 2,
                        icon: 'barrierObservationMethodIcon'
                    },
                    {
                        label: 'maturityDate',
                        value: 'maturityDate',
                        icon: 'earlyRedemptionIcon',
                        format: 'mediumDate'
                    },
                    {
                        label: 'bid',
                        value: 'bid'
                    },
                    {
                        label: 'ask',
                        value: 'ask'
                    },
                    {
                        label: ' ',
                        value: 'menu',
                        align: 'right',
                        notSortable: true
                    }
                    ]
                },
            "inSubscription": [{
                    label: 'couponPercentPa',
                    value: 'couponPercentPa',
                    precision: 2
                },
                {
                    label: 'underlyingNames',
                    value: 'underlyingNames',
                    icon: 'settlementMethodIcon',
                    minWidth: 200 // Minimum column width in pixels in the instrument table
                },
                {
                    label: 'currency',
                    value: 'currency',
                    icon: 'quantoIcon'
                },
                {
                    label: 'barrierLevelRelativePercent',
                    value: 'barrierLevelRelativePercent',
                    precision: 2
                },
                {
                    label: 'maturityDate',
                    value: 'maturityDate',
                    icon: 'earlyRedemptionIcon',
                    format: 'mediumDate'
                },
                {
                    label: 'subscriptionPeriodEndDate',
                    value: 'subscriptionPeriodEndDate',
                    format: 'customDateTime',
                    minWidth: 160 // Minimum column width in pixels in the instrument table
                },
                {
                    label: 'valor',
                    value: 'valor',
                    notSortable: true
                },
                {
                    label: ' ',
                    value: 'menu',
                    align: 'right',
                    notSortable: true
                }
            ],
            "secondaryMarket": [{
                    label: 'maxPerformancePercentStrikeCurrency',
                    value: 'maxPerformancePercentStrikeCurrency',
                    precision: 2
                },
                {
                    label: 'couponPercentPa',
                    value: 'couponPercentPa',
                    precision: 2
                },
                {
                    label: 'underlyingNames',
                    value: 'underlyingNames',
                    icon: 'settlementMethodIcon',
                    minWidth: 200 // Minimum column width in pixels in the instrument table
                },
                {
                    label: 'currency',
                    value: 'currency',
                    icon: 'quantoIcon'
                },
                {
                    label: 'distance2BarrierLevelPercent',
                    value: 'distance2BarrierLevelPercent',
                    precision: 2,
                    icon: 'barrierObservationMethodIcon'
                },
                {
                    label: 'maturityDate',
                    value: 'maturityDate',
                    icon: 'earlyRedemptionIcon',
                    format: 'mediumDate'
                },
                {
                    label: 'bid',
                    value: 'bid'
                },
                {
                    label: 'ask',
                    value: 'ask'
                },
                {
                    label: ' ',
                    value: 'menu',
                    align: 'right',
                    notSortable: true
                }
            ],
            "productDetail": {
                "categorization": [{
                    label: 'product_category',
                    value: 'metaMetaGroupName'
                },
                {
                    label: 'metaGroupName',
                    value: 'metaGroupName'
                },
                {
                    label: 'groupName',
                    value: 'groupName'
                }
                ],
                "lifecycle": [{
                    label: 'product_detail_subscriptionPeriodEndDate',
                    value: 'subscriptionPeriodEndDate',
                    visibleIf: 'inSubscription'
                },
                {
                    label: 'product_detail_fixingDate',
                    value: 'fixingDate'
                },
                {
                    label: 'product_detail_maturityDate',
                    value: 'maturityDate'
                },
                {
                    label: 'lastTradingDate',
                    value: 'lastTradingDate'
                },
                {
                    label: 'product_detail_redemptionDate',
                    value: 'redemptionDate'
                },
                {
                    label: 'product_early_redemption_option',
                    value: 'static',
                    staticValue: 'false'
                },
                {
                    label: 'days2MaturityDate',
                    value: 'days2MaturityDate',
                    precision: 0
                }
                ],
                "staticData": [{
                    label: 'issuer',
                    value: 'issuer'
                },
                {
                    label: 'underlyingNames',
                    value: 'underlyingNames'
                },
                {
                    label: 'issuePrice',
                    value: 'issuePrice',
                    precision: 2
                },
                {
                    label: 'currency',
                    value: 'currency'
                },
                {
                    label: 'isQuanto',
                    value: 'isQuanto'
                },
                {
                    label: 'settlementMethod',
                    value: 'settlementMethod'
                },
                {
                    label: 'quotingMethod',
                    value: 'quotingMethod'
                },
                {
                    label: 'notionalValue',
                    value: 'notionalValue',
                    precision: 0
                },
                {
                    label: 'listing',
                    value: 'inListing'
                },
                {
                    label: 'relativeStrike2ReferencePrice',
                    value: 'relativeStrike2ReferencePrice'
                }
                ],
                "coupons": [{
                    label: 'couponPercentPa',
                    value: 'couponPercentPa',
                    precision: 2
                },
                {
                    label: 'couponPaymentFrequency',
                    value: 'couponPaymentFrequency'
                },
                {
                    label: 'accruedInterestPriCurPercent',
                    value: 'accruedInterestPriCurPercent',
                    precision: 3
                }
                ],
                "couponPaymentDateAndInterest": [{
                    label: 'couponPaymentDate',
                    value: 'paymentDate'
                },
                {
                    label: 'couponPaymentInterest',
                    value: 'interest',
                    precision: 2
                }
                ],
                "barrier": [{
                    label: 'barrierLevelRelativePercent',
                    value: 'barrierLevelRelativePercent',
                    precision: 2
                },
                {
                    label: 'barrierObservationMethod',
                    value: 'barrierObservationMethod'
                },
                {
                    label: 'hasTouchedBarrier',
                    value: 'hasTouchedBarrier'
                }
                ],
                "pattern": [{
                    label: 'performanceSinceIssuePercent',
                    value: 'performanceSinceIssuePercent'
                },
                {
                    label: 'maxPerformancePercentStrikeCurrency',
                    value: 'maxPerformancePercentStrikeCurrency'
                },
                {
                    label: 'maxPerformancePercentPaPriceCurrency',
                    value: 'maxPerformancePercentPaPriceCurrency'
                }
                ],
                "underlyings": [{
                    label: 'underlying',
                    value: 'underlying'
                },
                {
                    label: 'price',
                    value: 'price',
                    precision: 2
                },
                {
                    label: 'performance_since_issue_percent',
                    value: 'performanceSinceIssuePercent'
                },
                {
                    label: 'strike',
                    value: 'strike',
                    precision: 2
                },
                {
                    label: 'barrierLevelAbsoluteReferenceCurrency',
                    value: 'barrierLevelAbsoluteReferenceCurrency',
                    precision: 2
                },
                {
                    label: 'distance2BarrierLevelPercent',
                    value: 'distance2BarrierLevelPercent'
                }
                ]
            }
        });
})();